import { useState, useEffect } from "react";
import { Container, ExpandedDivToBeClicked, PhotoContainer} from "./style";
import Modal from '../../Modal';

const Photo= ({className = "", label = "", photo = null, type = '4', openImageCropper, order, deleteImage, setCurrentSliderImage, setIsSliderOpen}) => {

    const handleOpenExpandedImage = () => {
        setCurrentSliderImage(order);
        setIsSliderOpen(true);
    }

    const SelectImageUrl = (isOriginal = false) => {
        const width = window.innerWidth;

        if(isOriginal){
            return photo.original_url;
        }

        if(width >= 600){
            return photo.medium_url;
        }else {
            return photo.small_url;
        }
    }


    if(!photo){
        return (
            <Container className = {className} >
        
            </Container>
        )
    }



    return (
        <PhotoContainer style={{backgroundImage: `url(${SelectImageUrl(photo.type === '4')})`}} className={className} photo = {photo}>
            <ExpandedDivToBeClicked onClick = {handleOpenExpandedImage}></ExpandedDivToBeClicked>
        </PhotoContainer>
    );
    
}

export default Photo;